import { useEffect, useState } from 'react'
import { Select } from '../Select_Required/Select.jsx'
import { formEETranslate } from '../../../i18n/translatedMessages.js'
import { Input } from '../Input/Input'
import jobMatch from '../../../API/JobMatch/jobMatch.js'
import Loading from '../../Loading/Loading.jsx'

export function SalarySelectorModal({ isOpen, onClose, onSelect, options = [], selected, user, areaList, levelList, isLoading, position }) {
	const [selectedId, setSelectedId] = useState(null)
	const [requestModalOpen, setRequestModalOpen] = useState(false)
	const [loading, setLoading] = useState(false)
	const [successMessage, setSuccessMessage] = useState('')
	const companyName = JSON.parse(localStorage.getItem('user'))?.name

	const [localUser, setLocalUser] = useState({
		name: '',
		email: '',
		country_id: '',
		level_id: '',
		area_id: '',
		position: '',
		salary: '',
		variableSalary: '',
	})

	useEffect(() => {
		if (isOpen && user) {
			setLocalUser({
				name: user.name ?? '',
				email: user.email ?? '',
				country_id: user.country ?? '',
				level_id: user.level ?? '',
				area_id: user.area ?? '',
				position: user.position ?? '',
				salary: user.salary ?? '',
				variableSalary: user.variableSalary ?? '',
			})
		}
	}, [isOpen, user])

	useEffect(() => {
		if (isOpen && user?.job_id_smtm && !selectedId) {
			setSelectedId(user.job_id_smtm)
		}
	}, [isOpen, user?.job_id_smtm, selectedId])

	const handleConfirm = () => {
		const selected = options.find(opt => opt.id === selectedId)
		if (selected) {
			onSelect(selected)
			if (!position) onClose()
		}
	}

	const handleChange = event => {
		const { name, value } = event.target
		setLocalUser(prev => ({ ...prev, [name]: value }))
	}

	const handleSend = async () => {
		try {
			setLoading(true)
			const data = {
				name: localUser?.name,
				email: localUser?.email,
				country_id: localUser?.country_id,
				level_id: localUser?.level_id,
				area_id: localUser?.area_id,
				position: localUser?.position,
				salary: localUser?.salary,
				variable_salary: localUser?.variableSalary,
				company_name: companyName,
			}
			await jobMatch.postNewPosition(data)

			setSuccessMessage('¡Puesto solicitado con éxito!')
			setTimeout(() => {
				setSuccessMessage('')
				setRequestModalOpen(false)
			}, 2000)
		} finally {
			setLoading(false)
		}
	}

	const formatNumber = value => {
		if (value === null || value === undefined || isNaN(value)) return ''
		return new Intl.NumberFormat('en-US', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		}).format(Number(value))
	}

	if (!isOpen) return null

	return (
		<>
			<div className='tw-fixed tw-inset-0 tw-bg-black/50 tw-flex tw-items-center tw-justify-center tw-z-50'>
				<div className='tw-bg-white tw-rounded-2xl tw-p-6 tw-w-full tw-max-w-5xl tw-shadow-lg'>
					<div className='tw-flex tw-justify-between tw-items-center tw-mb-4'>
						<h2 className='tw-text-lg tw-font-semibold'>Salario medio en el mercado</h2>
						<div onClick={onClose} className='tw-text-gray-500 hover:tw-text-black tw-cursor-pointer tw-text-5xl'>
							×
						</div>
					</div>

					{isLoading ? (
						<Loading />
					) : (
						<>
							<div className='tw-overflow-y-auto tw-max-h-96'>
								<table className='tw-w-full tw-text-base tw-text-left border-collapse'>
									<thead>
										<tr className='border-bottom tw-text-gray-400'>
											<th className='tw-py-2 tw-px-4'>Posición de Referencia</th>
											<th className='tw-py-2 tw-px-4'>Salario Fijo</th>
											<th className='tw-py-2 tw-px-4'>Salario Variable</th>
										</tr>
									</thead>
									{options.length === 0 ? (
										<tr>
											<td colSpan={3} className='tw-py-6 tw-px-4 tw-text-center tw-text-gray-500'>
												No se encontró ninguna posición para esta combinación. Intenta cambiar el área, nivel o país, o&nbsp;
												<span className='tw-text-purple-500 tw-underline tw-cursor-pointer' onClick={() => setRequestModalOpen(true)}>
													solicita un nuevo puesto
												</span>
												.
											</td>
										</tr>
									) : (
										<tbody>
											{options.map(opt => (
												<tr key={opt.id} className='border-bottom tw-cursor-pointer hover:tw-bg-gray-100' onClick={() => setSelectedId(opt.id)}>
													<td className='tw-py-3 tw-px-4'>
														<label className='tw-flex tw-items-center tw-gap-2'>
															<input
																type='radio'
																name='salaryOption'
																className='tw-text-purple-500 tw-bg-purple-500 tw-accent-purple-500'
																checked={selectedId === opt.id}
																onChange={() => setSelectedId(opt.id)}
															/>
															{opt.name}
														</label>
													</td>
													<td className='tw-py-2 tw-px-4'>{formatNumber(opt.fixedSalary)}</td>
													<td className='tw-py-2 tw-px-4'>{opt.variableSalary}</td>
												</tr>
											))}
										</tbody>
									)}
								</table>
							</div>
						</>
					)}

					{options.length > 0 && (
						<div className='tw-flex tw-items-center tw-justify-between tw-gap-2 tw-mt-4'>
							<div className='tw-w-3/5 tw-text-gray-500'>
								No encontraste un nombre o salario compatible? Prueba con otro nivel o{' '}
								<span className='tw-text-purple-500 tw-cursor-pointer' onClick={() => setRequestModalOpen(true)}>
									solicita un nuevo puesto
								</span>
								.
							</div>
							<div
								onClick={handleConfirm}
								className={`tw-bg-purple-500 tw-text-white tw-px-4 tw-py-2 tw-rounded tw-cursor-pointer ${
									!selectedId ? 'tw-opacity-50 tw-pointer-events-none' : ''
								}`}
							>
								Confirmar salario
							</div>
						</div>
					)}
				</div>
			</div>

			<RequestNewPositionModal
				isOpen={requestModalOpen}
				onClose={() => setRequestModalOpen(false)}
				user={user}
				areaList={areaList}
				levelList={levelList}
				handleChange={handleChange}
				handleSend={handleSend}
				successMessage={successMessage}
				localUser={localUser}
			/>
		</>
	)
}

function RequestNewPositionModal({ isOpen, onClose, areaList, levelList, user, handleChange, handleSend, successMessage, newPosition, localUser }) {
	if (!isOpen) return null

	const isFormValid = localUser?.country_id && localUser?.name && localUser?.email && localUser.level_id && localUser.area_id && localUser.position

	return (
		<div className='tw-fixed tw-inset-0 tw-bg-black/50 tw-flex tw-items-center tw-justify-center tw-z-50'>
			<div className='tw-bg-white tw-rounded-2xl tw-p-6 tw-w-full tw-max-w-xl tw-shadow-lg'>
				{successMessage ? (
					<div className='tw-text-green-600 tw-text-lg tw-font-semibold tw-text-center tw-p-6'>{successMessage}</div>
				) : (
					<>
						<div className='tw-flex tw-justify-between tw-items-center tw-mb-4'>
							<h2 className='tw-text-lg tw-font-semibold'>Solicitar nuevo puesto</h2>
							<div onClick={onClose} className='tw-text-gray-500 hover:tw-text-black tw-cursor-pointer tw-text-5xl'>
								×
							</div>
						</div>
						<p className='tw-text-gray-500 tw-text-base tw-mb-4'>
							¿No encontraste un puesto que se ajuste a tu necesidad? Completa los detalles a continuación para solicitar la inclusión de un nuevo
							puesto en el sistema.
						</p>

						<div className='tw-space-y-4'>
							<div>
								<Input
									label={formEETranslate.EEFormPosition}
									placeholder={'Nombre del puesto'}
									onChange={handleChange}
									name='position'
									value={localUser?.position}
									required
									error={''}
								/>
							</div>
							<div>
								<Select
									label={'Nivel Jerárquico'}
									placeholder={formEETranslate.EEFormSelect}
									onChange={handleChange}
									name='level_id'
									required
									value={localUser?.level_id}
									list={levelList}
								/>
							</div>
							<div>
								<Select
									label={'Área'}
									placeholder={formEETranslate.EEFormSelect}
									onChange={handleChange}
									name='area_id'
									required
									value={localUser?.area_id}
									list={areaList}
								/>
							</div>
							<div>
								<Input
									label={'Salario Fijo'}
									placeholder={'Salario Fijo'}
									onChange={handleChange}
									name='salary'
									value={localUser?.salary}
									error={''}
								/>
							</div>
							<div>
								<Input
									label={'Salario Variable'}
									placeholder={'Salario Variable'}
									onChange={handleChange}
									name='variableSalary'
									value={localUser?.variableSalary}
									error={''}
								/>
							</div>
						</div>

						<div className='tw-flex tw-justify-end tw-gap-2 tw-mt-6'>
							<div
								onClick={onClose}
								className='tw-border tw-border-gray-300 tw-rounded tw-px-4 tw-py-2 tw-text-base tw-text-gray-600 tw-cursor-pointer hover:tw-bg-gray-100'
							>
								Cancelar
							</div>
							<div
								onClick={isFormValid ? handleSend : null}
								className={`tw-px-4 tw-py-2 tw-rounded tw-text-base tw-cursor-pointer ${
									isFormValid ? 'tw-bg-purple-500 tw-text-white hover:tw-bg-purple-800' : 'tw-bg-gray-300 tw-text-gray-500 tw-pointer-events-none'
								}`}
							>
								Enviar Solicitud
							</div>
						</div>
					</>
				)}
			</div>
		</div>
	)
}
